const isSelectCorrect = (answers: Array<Record<string, string>>) => {
  const nonNeutral = answers.filter((answer: Record<string, any>) => answer.risk !== 'neutral');
  const allCorrectSelected = nonNeutral
    .filter((answer: Record<string, any>) => answer.correct === true)
    .every((answer: Record<string, any>) => answer.selected === true);
  const noWrongSelected = nonNeutral
    .filter((answer: Record<string, any>) => answer.correct === false)
    .every((answer: Record<string, any>) => answer.selected === false);
  return allCorrectSelected && noWrongSelected;
};

export default isSelectCorrect;
